// extracted by mini-css-extract-plugin
export var searchHeader = "_2c-0";
export var searchHeaderDark = "_2c-1";